import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CarAccident icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CarAccident } from '@sravni/design-system-icons'
 *
 * <CarAccident />
 * ```
 */
var CarAccident = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CarAccident", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#CarAccident__a)", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" },
        React.createElement("path", { d: "m19.735 9.695-2.115.807M5.715 10.502l-2.123-.807M16.708 13.73H14.69M8.637 13.73H6.62M17.622 10.502l-.677-3.239a2.02 2.02 0 0 0-1.976-1.604H8.446c-.937 0-1.751.645-1.964 1.558l-.768 3.285", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M4.6 18.575h1.817c.668 0 1.21-.543 1.21-1.211v-.808H15.7v.808c0 .668.542 1.21 1.21 1.21h1.817a1.01 1.01 0 0 0 1.009-1.009v-4.64a2.422 2.422 0 0 0-2.422-2.423h-11.3a2.422 2.422 0 0 0-2.422 2.422v4.642A1.01 1.01 0 0 0 4.6 18.575ZM3.592 16.556h16.144", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m4.15 7.846-1.74-.13a.021.021 0 0 1-.01-.04l1.815-1.022a.021.021 0 0 0 .004-.035l-2.21-1.93a.021.021 0 0 1 .016-.037l2.322.174a.021.021 0 0 0 .022-.027l-.902-3.575c-.005-.022.025-.035.039-.016C4.508 2.617 4.578 2.84 5.608 4.285c.01.013.03.012.037-.003l1.388-2.837a.021.021 0 0 1 .04.006l.412 2.395" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "CarAccident__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736)", d: "M0 0h20v20H0z" }))))); });

export { CarAccident };
//# sourceMappingURL=CarAccident.js.map
